import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './EditorSidebarElement.module.sass'
import { Close } from '@components/icons'


interface Props {
  selected?: boolean
  variant?: 'danger' | 'warning' | 'info'
  onClose?: () => void
  children?: React.ReactNode
  className?: string
}

const EditorSidebarElement = (props: Props) => {

  const { 
    selected = false,
    variant,
    onClose,
    children,
    className = '',
  } = props

  return (
    <div className={cn(styles.root, selected ? styles['root--selected'] : '', variant ? styles[`root--${variant}`] : '', className)}>
      {/* {!!onClose && (
        <button type="button" onClick={onClose} className={styles.close}>
          <Close />
        </button>
      )} */}
      {children}
    </div>
  )
}

export default EditorSidebarElement
